import { render, staticRenderFns } from "./assign-user-assets.vue?vue&type=template&id=3cd48d0a&scoped=true"
import script from "./assign-user-assets.vue?vue&type=script&lang=js"
export * from "./assign-user-assets.vue?vue&type=script&lang=js"
import style0 from "./assign-user-assets.vue?vue&type=style&index=0&id=3cd48d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd48d0a",
  null
  
)

export default component.exports